import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@smarterservices/smarter-ui';
import Header from './Header';
import Footer from './Footer';

/**
 * Default layout component with header and footer
 * 
 * @component
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to render within the layout
 * @returns {React.ReactElement} Layout with header, content area, and footer
 */
const DefaultLayout = ({ children }) => {
  useEffect(() => {
    // Add a class to body when this layout is mounted
    document.body.classList.add('has-footer');
    
    return () => {
      // Remove the class when component unmounts
      document.body.classList.remove('has-footer');
    };
  }, []);

  return (
    <Flex as="div"  direction="column" width="100%" height="calc(100% - 60px)">
      <Flex.Item as="div"  className="header">
        <Header />
      </Flex.Item>
      <Flex.Item 
        as="div" 
        maxHeight="calc(100% - 60px)"
        shouldGrow 
        shouldShrink 
        className="main-content with-footer" 
        background="secondary">
        {children}
      </Flex.Item>
      <Flex.Item as="div" className="footer">
        <Footer />
      </Flex.Item>
    </Flex>
  );
};

DefaultLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DefaultLayout;